import { render, staticRenderFns } from "./InfoToast.vue?vue&type=template&id=2427b964&scoped=true&"
import script from "./InfoToast.vue?vue&type=script&lang=ts&"
export * from "./InfoToast.vue?vue&type=script&lang=ts&"
import style0 from "./InfoToast.vue?vue&type=style&index=0&id=2427b964&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427b964",
  null
  
)

export default component.exports